import dayjs from 'dayjs';
import { DATE_FORMATS } from 'src/const';

export const DateUtils = {
  formatDate: (date: Date, format = DATE_FORMATS.DATE_MONTH_YEAR) => {
    return dayjs(date).format(format);
  },

  covertToDate: (
    dateStr: string,
    format = DATE_FORMATS.DATE_MONTH_YEAR
  ): Date => {
    return dayjs(dateStr, format).toDate();
  },

  covertToDateForInput: (
    dateStr: string,
    format = DATE_FORMATS.YEAR_MONTH_DATE
  ): Date | null => {
    const inputDay = dayjs(dateStr, format);
    const todayDay = dayjs();
    if (todayDay.diff(inputDay, 'year') < 100) {
      return dayjs(dateStr, format).toDate();
    }
    return null;
  },

  compareTwoDate: (date1, date2) => {
    date1 = date1.split('/').reverse().join('-');
    date2 = date2.split('/').reverse().join('-');
    if (date1 > date2) return 1;
    else if (date1 < date2) return -1;
    else return 0;
  },
  isValidDate: (dateInput: string) => {
    if (dateInput.length !== 10) return false;
    const numbers = dateInput.split('/');
    const dateVal = numbers[0];
    const monthVal = numbers[1];
    const yearVal = numbers[2];
    const date = new Date(`${monthVal}-${dateVal}-${yearVal}`)
    return !isNaN(date.getTime()) && date.getDate() == Number(dateVal) && date.getMonth() + 1 == Number(monthVal) && date.getFullYear() == Number(yearVal)
  },
  isLeapYear: (year) => {
    return !((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
  },
};
